import {styled} from "@mui/material";

export const Wrapper = styled('div')({
  marginBottom: 20,
});

export const Title = styled('div')({
  marginBottom: 5,
});
